export default __webpack_public_path__ + "dist/media/Check.b4574d0f.svg";